export const Admin = {
    pass: '1234'
}